/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'

import {
  Spinner,
  Report,
  ReportHeader,
  ImpactReportInvestmentsSection,
  ImpactReportLoansSection,
  ImpactReportEmployerSwitcher
} from '../components'

import {
  IMPACT_REPORT_DATE
} from '../constants'

class ImpactReport extends React.Component {
  static propTypes = {
    employerId: PropTypes.string,
    match: PropTypes.shape({
      params: PropTypes.shape({
        employer: PropTypes.string.isRequired
      })
    })
  }

  state = {
    employerId: this.props.employerId || this.props.match.params.employer
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let employerId = nextProps.employerId || nextProps.match.params.employer
    if (employerId) {
      this.setState({ employer: employerId })
    } else if (nextProps.data.me) {
      this.setState({ employer: nextProps.data.me.contact.employer.id })
      if (!this.props.employerId) {
        this.props.history.push({
          pathname: `/os/insights/impact/${nextProps.data.me.contact.employer.id}`
        })
      }
    }
  }

  render () {
    if (this.props.data.loading) {
      return <Spinner type='tail' />
    }

    if (this.props.data.error) {
      return <div>We&rsquo;re experiencing a problem loading the required report data</div>
    }

    let employer = this.props.data.employer
    let queryParams = qs.parse(this.props.location.search)
    // Allows for overriding the date to show alternative dates for internal review before updating envvar
    let metricsDate = IMPACT_REPORT_DATE
    if (queryParams.date) {
      metricsDate = queryParams.date
    }

    let latestMetricsDate = moment.utc(metricsDate)

    return (
      <div className="stage-main slds-size_1-of-1">
        <Report
          header={
            <ReportHeader
              heading="Impact report"
              date={latestMetricsDate.format("MMMM YYYY")}
              subheading1={
                <ImpactReportEmployerSwitcher
                  value={this.state.employerId}
                  onChange={(e) => this.props.history.push({
                    pathname: `/os/insights/impact/${e.target.value}`
                  })}
                  className="slds-size_1-of-4"
                />
              }
              subheading2={employer.employergroup
                ? employer.employergroup.friendlyName
                : ''
              }
              valuesAtDate={latestMetricsDate.format("DD MMMM YYYY")}  // TODO: use correct date
            />
          }
          content={[
            <ImpactReportInvestmentsSection
              employer={this.state.employerId}
              metricsDate={latestMetricsDate}
              key='impactReportInvestmentsSection'
            />,
            <ImpactReportLoansSection
              employer={this.state.employerId}
              metricsDate={latestMetricsDate}
              key='impactReportLoansSection'
            />,
            // TODO: uncomment below and implement when we've got the data to plot graph over time range
            // <Graph
            //   heading="Savings vs outstanding loans"
            //   width={900}
            //   height={300}
            //   horizontalGridLines={true}
            //   xAxis={true}
            //   yAxis={true}
            //   lineSeries={[
            //     {
            //       data: [
            //         {x: 0, y: 10},
            //         {x: 1, y: 9},
            //         {x: 2, y: 8},
            //         {x: 3, y: 6},
            //         {x: 4, y: 7},
            //         {x: 5, y: 6},
            //         {x: 7, y: 5}
            //       ],
            //       colour: "#e4a538"
            //     },
            //     {
            //       data: [
            //         {x: 0, y: 0},
            //         {x: 2, y: 4},
            //         {x: 3, y: 6},
            //         {x: 4, y: 8},
            //         {x: 5, y: 9},
            //         {x: 6, y: 10},
            //         {x: 7, y: 12}
            //       ],
            //       colour: "#88d16f"
            //     }
            //   ]}
            // />
          ]}
        />
      </div>
    )
  }
}

const getEmployerReportMetrics = gql`
  query ($employer: ID!) {
    employer(id: $employer){
      id
      friendlyName
      employergroup {
        id
        friendlyName
      }
    }
  }
`

const withData =
  graphql(getEmployerReportMetrics, {
    options: (ownProps) => ({
      variables: {
        employer: ownProps.employerId || ownProps.match.params.employer
      }
    })
  })

export default compose(
  withData,
  withRouter
)(ImpactReport)



// WEBPACK FOOTER //
// ./src/containers/ImpactReport.js